import {Component, ComponentFactoryResolver, ComponentRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {NgForm} from '@angular/forms';

import {Event, EventId} from '../../../models/base/event';

import {Query} from '../../../models/query/query';
import {QueryCriterionComponent} from './query-criterion-component';
import {Criteria} from '../../../models/query/criteria';
import {QueryFields} from '../../../models/ui/query-fields';
import {Criterion} from 'app/models/query/criterion';
import {Stockroom} from 'app/models/stockroom/stockroom';
import {ClientSettingsService} from 'app/services/settings/client-settings.service';

@Component({
  selector: 'bms-query',
  templateUrl: './query-component.html',
  providers: [QueryCriterionComponent]
})
export class QueryComponent {

  integerPattern = '^[0-9]+$';
  integerPatterngGeaterThanZero = '^[1-9][0-9]*$';
  realPattern = '^((\\+|-)?([0-9]+)(\\.[0-9]+)?)|((\\+|-)?\\.?[0-9]+)$';
  realPatternTwoDecimal = '[-+]?[0-9]*[.]?([0-9][0-9]?)?';
  realPatternThreeDecimal = '[-+]?[0-9]*[.]?([0-9]{1,3})?';
  zipCodePattern = '[0-9]{5}';
  tinPattern = '[0-9]{9}';
  indCodePattern = '[0-9]{5}';
  idNumberPattern = '[0-9]{8}';
  colorPattern = '[0-9A-Fa-f]+';

  @Input()
  @Output()
  query: Query;
  maxResults: number;
  sortFieldName: string;
  sortOrder: string;
  @Input()
  showMaxResults: boolean = true;

  @Input()
  fields: QueryFields;

  @Output()
  events: EventEmitter<Event> = new EventEmitter();

  @ViewChild('citerionContainer', { read: ViewContainerRef, static: false })
  criterionContainer: ViewContainerRef;

  @ViewChild('baseCriterion', { read: QueryCriterionComponent, static: false })
  baseCriterion: QueryCriterionComponent;

  comps: ComponentRef<QueryCriterionComponent>[];

  activeStockroom: Stockroom;
  currentPage: number = 1;
  documentsPerPage = 10;

  constructor(private _componentFactoryResolver: ComponentFactoryResolver, private clientSettingsService: ClientSettingsService) {
    this.comps = [];
    this.maxResults = 0;
    this.sortFieldName = '';
    this.sortOrder = Query.ASC;
    this.activeStockroom = this.clientSettingsService.getActiveStockroom();
  }

  hideFilter() {
    $('div.filter').css('display', 'none')
  }

  newCriterion() {
    const factory = this._componentFactoryResolver.resolveComponentFactory(QueryCriterionComponent);
    const compRef = this.criterionContainer.createComponent(factory);
    compRef.instance['events'].subscribe($.proxy(this.onEvent, this));
    compRef.instance['index'] = this.comps.push(compRef);
    compRef.instance['query'] = this.query;
    compRef.instance['fields'] = this.fields;
  }

  clearCriteria() {
    this.baseCriterion.reset();
    this.comps.forEach(comp => comp.destroy());
  }

  toggleSortOrder() {
    if (this.sortOrder === Query.ASC) {
      this.sortOrder = Query.DESC;
    } else {
      this.sortOrder = Query.ASC;
    }
  }

  onApplyFilter(form: NgForm) {
    let criteria: Criteria;
    let empty: boolean;

    if (!!this.query.parameters['clear_query'] && this.query.parameters['clear_query'] === 'no') {
      if (this.baseCriterion.isValid()) {
        criteria = this.query.and();
      }
      empty = false;
    } else {
      this.query.clear();
      criteria = this.query.and();
      empty = true;
    }


    if (this.baseCriterion.isValid()) {
        criteria.and(this.baseCriterion.getCriterion());
        empty = false;
    }
    this.comps.forEach(comp => {
      if (comp.instance.isValid()) {
        criteria.and(comp.instance.getCriterion())
        empty = false;
      }
    });
    if (empty) {
        this.query.clear();
    }

    if (this.sortFieldName != null && this.sortFieldName !== '') {
        this.query.clearOrder();
        this.query.addOrderByField(this.query.alias, this.sortFieldName, this.sortOrder);
    }

    if (this.showMaxResults) {
        this.query.limit = this.maxResults;
    }
    this.events.next(new Event(EventId.APPLY_QUERY, this));
  }

  onResetFilter(form: NgForm) {
    this.clearCriteria();
    this.query.clear();
    if (!!this.query.parameters['clear_query'] && this.query.parameters['clear_query'] === 'no') {
        this.query.and().and( Criterion.equal( 'doc', 'document_type_id', 13 ) );
        this.query.and().and( Criterion.equal( 'doc', 'status', 'V' ) );
        this.query.and().and( Criterion.equal( 'doc', 'stockroom_recipient', this.activeStockroom.id));
        this.query.addOrderByField( 'doc', 'document_date', 'desc' );
        this.query.addOrderByField( 'doc', 'document_number', 'desc' );
        this.query.offset = this.currentPage;
        this.query.limit = this.documentsPerPage;
    }
     this.events.next(new Event(EventId.APPLY_QUERY, this));
  }

  onEvent(event: Event) {
    if (event.id === EventId.QUERY_CRITERION_REMOVE) {
      const idx = this.comps.findIndex(cmp => cmp.instance === <QueryCriterionComponent>event.object);
      if (idx > -1) {
        this.comps[idx].destroy();
        this.comps.slice(idx, 1);
      }
    }
  }
}
